import { StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { formatMoneyBRL } from "../../../helpers/util";
import * as Colors from "../../../styles/colors"
import * as Fonts from "../../../styles/typography"
import Icon from "react-native-vector-icons/MaterialCommunityIcons";

export default function CreditBox({ creditValue = 0,
    crediPrice = 0,
    checked = false,
    onPress, }) {
    return <TouchableOpacity style={styles.principalView} onPress={onPress}>
        <View style={styles.checkView}>
            {checked ? <View style={styles.checkedView} /> : null}
        </View>
        <View style={styles.creditPriceSecondaryView}>
            <Text style={styles.youPayText}>{"Você paga"}</Text>
            <Text style={styles.creditPriceText}>{formatMoneyBRL(crediPrice)}</Text>
        </View>
        <View style={styles.creditValueSecondaryView}>
            <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
                {/* <Icon name={"circle-multiple-outline"} size={30} color={Colors.WHITE} /> */}
                <Text style={styles.youEarnText}>{"Você recebe"}</Text>
            </View>
            <View style={{
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center"
            }}>
                <Text style={styles.creditValueText}>{formatMoneyBRL(creditValue)}</Text>
            </View>
        </View>
        {/* <Icon
            name={"arrow-right-bold"}
            style={{
                position: "absolute",
                top: 16,
                left: 170
            }}
            size={42}
            color={Colors.PRIMARY} /> */}
    </TouchableOpacity>
}

const styles = StyleSheet.create({
    principalView: {
        backgroundColor: Colors.GRAY_LIGHT,
        marginVertical: 8,
        borderRadius: 8,
        flexDirection: "row",
        justifyContent: "space-between",
        borderRadius: 8,
        flexDirection: "row",
        alignItems: "center",
        marginTop: 8,
        backgroundColor: Colors.SNOW,
        borderColor: Colors.SECONDARY,
        borderLeftWidth: 2,
        shadowColor: Colors.GRAY_DARK,
        shadowOffset: {
            width: 0,
            height: 2,
        },
        shadowOpacity: 0.25,
        shadowRadius: 4,
        elevation: 5,
        borderRadius: 8,
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
    },
    youPayText: {
        fontSize: Fonts.FONT_SIZE_22,
    },
    youEarnText: {
        fontSize: Fonts.FONT_SIZE_22,
        color: Colors.WHITE,
        marginLeft: 4,
    },
    creditPriceText: {
        fontSize: Fonts.FONT_SIZE_26,
        fontWeight: "400",
    },
    creditValueText: {
        fontSize: Fonts.FONT_SIZE_28,
        fontWeight: "500",
        color: Colors.WHITE,
        marginLeft: 8
    },
    creditPriceSecondaryView: {
        alignItems: "center",
        justifyContent: "center",
        width: "40%"
    },
    creditValueSecondaryView: {
        alignItems: "center",
        // marginHorizontal: 8,
        justifyContent: "center",
        backgroundColor: Colors.SECONDARY,
        width: "48%",
        borderTopRightRadius: 5,
        borderBottomRightRadius: 5
    },
    checkView: {
        borderWidth: 1,
        width: 24,
        height: 24,
        borderRadius: 24,
        padding: 2,
        marginLeft: 16,
        alignItems: "center",
        justifyContent: "center",
    },
    checkedView: {
        flex: 1,
        flexGrow: 1,
        width: "100%",
        borderRadius: 8,
        backgroundColor: Colors.INFO,
    },
})